import { cn } from '@mint-lib/tw-utils';

export const DotStepper = ({
  steps,
  activeStep,
}: {
  steps: number;
  activeStep: number;
}) => {
  const stepIds = Array.from({ length: steps }, (_, index) => `step-${index}`);

  return (
    <div className="mb-10 flex gap-4">
      {stepIds.map((stepId, index) => (
        <div
          key={stepId}
          className={cn(
            'h-2 w-2 rounded-full',
            activeStep === index ? 'bg-ui-inverse02' : 'bg-ui-tertiary',
          )}
        />
      ))}
    </div>
  );
};
